import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { CreateFolderImplementation } from '../implementation/CreateFolderImplementation';
import { LocalStorageSvc } from '../services/localStorage.service';
import { Controller } from './Controller';

export class CreateFolderController extends Controller{
    public fileOperationsImplementation:any;
    public createFolderImplementation:any;
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    public fileOpsController:any;
    public loggerService:any;
    public localStorageSvc: LocalStorageSvc;
    public folderService:any;
    public listService:any
     

    public constructor(public globalService:GlobalService) {
      super(globalService);
      this.createFolderImplementation = CreateFolderImplementation.getInstance(globalService)
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
      this.localStorageSvc = this.globalService.getLocalStorageSvcRef()
    }
    
    public static getInstance(globalService):CreateFolderController{
		if(this.singleInstance == null){
			this.singleInstance = new CreateFolderController(globalService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}


    public setEnvObjects(globalService){
    this.universalService=globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();   
    this.fileOpsController = FileOperationsController.getInstance(globalService);
    this.loggerService = globalService.getLoggerServiceRef();
    this.folderService = globalService.getFolderServiceRef();
    this.listService = globalService.getListServiceRef();
    }    

    async createFolder(folderName){
        try{
            var result;
            this.fileOperationsImplementation.setHandler(this.globalService);
            var url = window.location.href;
            if(url.includes("teamfolders") && this.universalService.allowUpload){
              result = await this.fileOpsController.createFolderInsideTeamFolder(folderName,this.folderService.currentFolder);
            } else if(url.includes("sharedwithme") && this.universalService.allowUpload){
              result = await this.fileOpsController.createFolderInsideSharedWithMeFolder(folderName,this.folderService.currentFolder);
            }else{
              result = await this.fileOpsController.createFolder(folderName);
            }
            if(result == "folder created"){
              AppEvents.globalObservable.next({createFolder: false});
              this.fetchLatestFolders(this.universalService.createFolderApiResponse);
            }
          }catch(exc){
            this.loggerService.log("exception for creating folder",exc)
          }
    }


    fetchLatestFolders(newFolderData){
        this.createFolderImplementation.setHandler(this.globalService);
        this.createFolderImplementation.updateCreatedFolderInView(newFolderData);
    }
}